import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() itemCount = 0;
  @Input() itemsPerPageOptions = [10, 20, 30, 50];
  @Input() pageButtonCount = 5; // Número de botones de página a mostrar

  @Output() onPreviousClick = new EventEmitter<void>();
  @Output() onNextClick = new EventEmitter<void>();
  @Output() onPageClick = new EventEmitter<number>();

  // Obtener las páginas que se deben mostrar
  getPages(): number[] {
    const pages: number[] = [];
    const maxButtons = this.pageButtonCount;
    const half = Math.floor(maxButtons / 2);
    
    let start = Math.max(1, this.currentPage - half);
    let end = Math.min(this.totalPages, start + maxButtons - 1);
    
    // Ajustar el inicio si estamos cerca del final
    if (end - start + 1 < maxButtons) {
      start = Math.max(1, end - maxButtons + 1);
    }
    
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    
    return pages;
  }

  // Ir a página anterior
  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.onPreviousClick.emit();
    }
  }

  // Ir a página siguiente
  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.onNextClick.emit();
    }
  }

  // Ir a página específica
  goToPage(pageIndex: number) {
    const pageNumber = pageIndex + 1;
    if (pageNumber >= 1 && pageNumber <= this.totalPages && pageNumber !== this.currentPage) {
      this.onPageClick.emit(pageIndex);
    }
  }
}
